var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.799 3.25L23.0263 17.5C23.6036 18.5 22.8819 19.75 21.7272 19.75H5.27276C4.11806 19.75 3.39637 18.5 3.97372 17.5L12.201 3.25C12.7783 2.25 14.2217 2.25 14.799 3.25Z",
    fill: "white",
    stroke: "#E40000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.276 8.456H12.344L12.728 14.324H13.88L14.276 8.456ZM14.204 17V15.224H12.416V17H14.204Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.f897e92163da771de83710d4ff278223.svg";
export { ForwardRef as ReactComponent };